import { render, staticRenderFns } from "./SafetyDetail.vue?vue&type=template&id=95a500d8&scoped=true"
import script from "./SafetyDetail.vue?vue&type=script&lang=js"
export * from "./SafetyDetail.vue?vue&type=script&lang=js"
import style0 from "./SafetyDetail.vue?vue&type=style&index=0&id=95a500d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a500d8",
  null
  
)

export default component.exports